/* raw layout hash: _default-web-layout:ba892550ccfa30c935a4e77556aec356d543808e404572556ce02d2293b90d16 */
import React from 'react';
import WebShell from './WebShell.jsx';

/**
 * The baseline web layout — brand navbar, primary menu, mobile bottom nav,
 * footer. Used by every page that needs no layout-specific assets.
 *
 * Source: RawHTMLDesign/layouts/_default-web-layout.html
 */
export default function DefaultWebLayout() {
  return <WebShell />;
}
